export default __webpack_public_path__ + "static/media/NEAS0490.34I-37203_-22043_0.16fa6531.jpg";